var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 146,
    viewBox: "0 0 134 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M94.63 105.62C94.63 93.0197 82.1 82.8 66.63 82.8C51.16 82.8 38.63 93.0197 38.63 105.62",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M66.6299 65.9999C75.6377 65.9999 82.9399 58.6976 82.9399 49.6898C82.9399 40.6821 75.6377 33.3801 66.6299 33.3801C57.6222 33.3801 50.3199 40.6821 50.3199 49.6898C50.3199 58.6976 57.6222 65.9999 66.6299 65.9999Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M130.19 49.0602V96.94C130.19 104.78 125.99 112.06 119.2 116.05L77.62 140.06C70.83 143.98 62.43 143.98 55.57 140.06L13.99 116.05C7.2 112.13 3 104.85 3 96.94V49.0602C3 41.2202 7.2 33.9399 13.99 29.9499L55.57 5.94C62.36 2.02 70.76 2.02 77.62 5.94L119.2 29.9499C125.99 33.9399 130.19 41.1502 130.19 49.0602Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/service3.c83b6fc2591aceae7635cfe6c9187e59.svg";
export { ForwardRef as ReactComponent };